import {capitalize, translate} from "./functions";

$(function () {
    const $body = $("body"),
        $root = $body.find('.root');

    $root.find('.js-back').on('click', e => {
        e.preventDefault();

        if (document.referrer) {
            window.location.href = document.referrer;
        } else {
            window.history.back();
        }
    });

    $body.on('click', 'a:not(.js-handle)', e => {
        const $link = $(e.currentTarget),
            href = $link.attr('href');

        if (href.includes('delete') || href.includes('usun')) {
            e.preventDefault();

            translate('are you sure you want to delete this').then(message => {
                if (confirm(capitalize(message) + '?')) {
                    window.location.href = href;
                }
            });
        }
    });
});